import { Box } from "@mui/material";
import { Suspense } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom"; //HashRouter
import AutorenewIcon from "@mui/icons-material/Autorenew";
//lazy load components
import ProtectedRoute from "../ProtectedRoute";
import Fallback from "../pages/Fallback/Fallback";
import Login from "../pages/Signin/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import Pin from "../pages/Pin/Pin";
import VehicleReport from "../pages/Dashboard/VehicleReport";
import VehicleRoutes from "../pages/Dashboard/VehicleRoutes";
import DeliveryItem from "../pages/Dashboard/DeliveryItem";
import AppLayout from "./AppLayout";
import Cashup from "../pages/Cashup/Cashup";
import Returns from "../pages/Returns/Returns";
import ReturnVehicleReport from "../pages/Dashboard/ReturnVehicleReport";
import ReportAccident from "../pages/Accidents/ReportAccident";
import CustomerOrder from "../pages/Customer/CustomerOrder";
import CustomerInvoice from "../pages/Customer/CustomerInvoice";
export default function App() {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <Box
            style={{
              display: "block",
              width: "100%",
              textAlign: "center",
              paddingTop: "10%",
            }}
          >
            <AutorenewIcon />
          </Box>
        }
      >
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/customer-order/:id" element={<CustomerOrder />} />
          <Route path="/customer-invoice/:id" element={<CustomerInvoice />} />
          
          <Route element={<AppLayout />}>
            <Route
              path="/dashboard"
              onLeave={() => {
                alert("helloo dont go");
              }}
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pin"
              element={
                <ProtectedRoute>
                  <Pin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/report"
              element={
                <ProtectedRoute>
                  <VehicleReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/return_defect"
              element={
                <ProtectedRoute>
                  <ReturnVehicleReport />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/routes"
              element={
                <ProtectedRoute>
                  <VehicleRoutes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/order"
              element={
                <ProtectedRoute>
                  <DeliveryItem />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cashup"
              element={
                <ProtectedRoute>
                  <Cashup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/returns"
              element={
                <ProtectedRoute>
                  <Returns />
                </ProtectedRoute>
              }
            />
            <Route
              path="/accident"
              element={
                <ProtectedRoute>
                  <ReportAccident />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route
            path="*"
            element={
                <Fallback />
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
